<script setup lang="ts">
import { Dialog as HeadlessDialog, DialogTitle, DialogPanel } from "@headlessui/vue";

export type DialogProps = {
  isOpen: boolean;
  isCloseButtonDisabled?: boolean;
  isCloseButtonDisplayed?: boolean;
};

defineOptions({
  inheritAttrs: false,
});

withDefaults(defineProps<DialogProps>(), {
  isCloseButtonDisplayed: true,
  isCloseButtonDisabled: false,
});

const emit = defineEmits(["close"]);

const close = () => emit("close");

const dialogTitle = ref<HTMLElement>();
</script>

<template>
  <HeadlessDialog
    :open="isOpen"
    :initial-focus="dialogTitle"
    @close="close()"
    aria-labelledby="dialog-title"
  >
    <div class="fixed inset-0 z-[100] bg-black/30" aria-hidden="true" />
    <div class="fixed inset-0 z-[100] flex items-center justify-center p-4" role="dialog">
      <DialogPanel
        v-bind="$attrs"
        class="flex select-none flex-col justify-center gap-6 rounded-2xl bg-white p-10"
      >
        <div class="flex w-full justify-between">
          <DialogTitle class="relative flex text-2xl font-bold text-ppa-dark-blue">
            <div ref="dialogTitle" id="dialog-title" class="m-0 flex-grow">
              <slot name="title"></slot>
            </div>
          </DialogTitle>
          <button
            class="w-8"
            role="button"
            :aria-label="$t('dialog.close')"
            :disabled="isCloseButtonDisabled"
          >
            <img src="../assets/close.svg" alt="" aria-hidden="true" @click="close()" />
          </button>
        </div>
        <slot name="content"></slot>

        <div class="flex justify-end gap-4">
          <slot name="actions"></slot>
        </div>
      </DialogPanel>
    </div>
  </HeadlessDialog>
</template>
